
const Card = ({ component, title }) => {

    return (<>
        <div className={"container pt-sm-5 pt-5-sm pt-2-xs mb-5"}>
            <div className={"row"}>
                <div className={"col-sm-1  col-xs-0"} ></div>
                <div className={"col-sm-10  col-xs-10"} >
                    <div className={"card"}>
                        <h2 className={"card-header"} style={{fontSize: '18px'}}>
                            <strong>{
                                title ?? ""
                            }</strong> 
                        </h2>
                        <div className={"card-body "}>
                            <div className={"pt-2"}>
                                {component}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"col-sm-1 col-xs-0"} ></div>
            </div>
        </div>
    </>)

}

export default Card